import {
  GET_LIST_DUNOCHOVAY,
  GET_LIST_DUNOCHOVAY_SUCCESS,
  GET_LIST_DUNOCHOVAY_FAILURE,
} from "../../actions/DuNoChoVay/actionTypes";

const initialState = {
  List: [],
  TongDuNo: 0,
  Tong_NoRuiRo: 0,
  Tong_NoXau: 0,
  TotalNoGoc: 0,
};
const getListDuNoChoVay = (state, action) => ({
  ...state,
  getListDuNoChoVayLoading: true,
});

const getListDuNoChoVaySuccess = (state, action) => {
  return {
    ...state,
    List: action.payload.List,
    TongDuNo: action.payload.TongDuNo,
    Tong_NoRuiRo: action.payload.Tong_NoRuiRo,
    Tong_NoXau: action.payload.Tong_NoXau,
    TotalNoGoc: action.payload.TotalNoGoc,
    getListDuNoChoVayLoading: false,
  };
};

const getListDuNoChoVayFailed = (state, action) => ({
  ...state,
  getListDuNoChoVayLoading: false,
  List: [],
});
export const listDuNoChoVayReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_DUNOCHOVAY:
      return getListDuNoChoVay(state, action);
    case GET_LIST_DUNOCHOVAY_SUCCESS:
      return getListDuNoChoVaySuccess(state, action);
    case GET_LIST_DUNOCHOVAY_FAILURE:
      return getListDuNoChoVayFailed(state, action);
    default:
      return state;
  }
};

export default listDuNoChoVayReducer;
